import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { authRoutes } from "./AuthRoutes";
import LayoutRoutes from "../Route/LayoutRoutes";
import Signin from "../Auth/Signin";
import PrivateRoute from "./PrivateRoute";
import { isAuthenticated } from "../api/client";
import { getStoredUser } from "../api/auth";
import { ensureDefaultLayoutStorage, getActiveLayoutSlug } from "../constants/layout";
import { roleHomePath } from "../constants/menuAccess";
import { APP_BASENAME } from "../constants/appBase";

const Routers = () => {
  ensureDefaultLayoutStorage();
  const layout = getActiveLayoutSlug();
  const homePath = roleHomePath(getStoredUser(), layout);
  const loginPath = "/login";

  return (
    <BrowserRouter basename={APP_BASENAME && APP_BASENAME !== "/" ? APP_BASENAME : undefined}>
      <Routes>
        <Route path={loginPath} element={<Signin />} />
        {authRoutes.map(({ path, Component }, i) => (
          <Route path={path} element={Component} key={i} />
        ))}

        <Route element={<PrivateRoute />}>
          <Route
            path="/"
            element={<Navigate replace to={isAuthenticated() ? homePath : loginPath} />}
          />
          <Route path="/*" element={<LayoutRoutes />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Routers;
